import { useEffect, useState } from "react";

import { useOrderContext } from "../contexts/OrderContext";
import { NewOrderQueryDataReducerActionTypes } from "../contexts/reducers/newOrderQueryDataReducer";
import {
  LocationFragment,
  MaterialFragment,
  StockTypeFragment,
} from "../models/autogenerated-deliveryService-gql/graphql";
import useLocationsQuery from "./graphql-hooks/queries/useLocationsQuery";
import useMaterialsQuery from "./graphql-hooks/queries/useMaterialsQuery";
import useStockTypesQuery from "./graphql-hooks/queries/useStockTypesQuery";

/**
 * Custom hook to query data needed within the NewOrderContext.
 */

export const useNewOrderQueryData = () => {
  const { queryData, dispatchQueryData } = useOrderContext();

  const [materials, setMaterials] = useState<MaterialFragment[]>();
  const [stockTypes, setStockTypes] = useState<StockTypeFragment[]>();
  const [locations, setLocations] = useState<LocationFragment[]>();

  const { loading: loadingMaterials, error: materialsError } =
    useMaterialsQuery({
      dataAction: (collection) => setMaterials(collection.data),
    });

  const { loading: loadingStockTypes, error: stockTypesError } =
    useStockTypesQuery({
      dataAction: (collection) => setStockTypes(collection.data),
    });

  const { loading: loadingLocations, error: locationsError } =
    useLocationsQuery({
      dataAction: (collection) => setLocations(collection.data),
    });

  const loading = loadingMaterials || loadingStockTypes || loadingLocations;
  const error = materialsError || stockTypesError || locationsError;

  useEffect(() => {
    if (!materials || !stockTypes || !locations) return;

    dispatchQueryData({
      type: NewOrderQueryDataReducerActionTypes.SetState,
      value: { materials, stockTypes, locations },
    });
  }, [materials, stockTypes, locations]);

  return { queryData, loading, error };
};
